module.exports = __webpack_public_path__ + "media/images/emblems/Wiesendangen-blazon-1824a74322f5433d81fd351cc59f9e4e.svg";